/* eslint-disable no-unused-vars */
import {RxCollection} from 'rxdb';
import {AlertModel} from '../../models';
import {DataSource} from './data-source';
import {SearchModel} from '../../models/search.model';

export class SearchDataSource extends DataSource<SearchModel> {

    constructor(collection: RxCollection) {
        super(collection);
    }
}
